// apps/web/src/api/notifications.ts — typed wrappers around
// `/api/notifications/*` (#1068, #1069, #1070). Settings reads + writes
// the per-user `NotificationPreferences` row through these calls. The
// bell surface (#1070) calls `listNotifications` + `markNotificationViewed`.
import {
  NotificationAggregateItemSchema,
  NotificationListResponseSchema,
  NotificationPreferencesSchema,
  type NotificationAggregateItem,
  type NotificationListResponse,
  type NotificationMarkViewedBody,
  type NotificationPreferences,
  type NotificationPreferencesUpdateInput,
} from '@magimp/shared';
import { request } from './client.js';

export function getNotificationPreferences(): Promise<NotificationPreferences> {
  return request<NotificationPreferences>(
    '/notifications/preferences',
    { method: 'GET' },
    {},
    NotificationPreferencesSchema,
  );
}

export function patchNotificationPreferences(
  body: NotificationPreferencesUpdateInput,
): Promise<NotificationPreferences> {
  return request<NotificationPreferences>(
    '/notifications/preferences',
    {
      method: 'PATCH',
      body: JSON.stringify(body),
      headers: { 'content-type': 'application/json' },
    },
    {},
    NotificationPreferencesSchema,
  );
}

export function listNotifications(): Promise<NotificationListResponse> {
  return request<NotificationListResponse>(
    '/notifications',
    { method: 'GET' },
    {},
    NotificationListResponseSchema,
  );
}

export function markNotificationViewed(
  body: NotificationMarkViewedBody,
): Promise<NotificationAggregateItem> {
  return request<NotificationAggregateItem>(
    '/notifications/mark-viewed',
    {
      method: 'POST',
      body: JSON.stringify(body),
      headers: { 'content-type': 'application/json' },
    },
    {},
    NotificationAggregateItemSchema,
  );
}
